import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { DragulaModule } from 'ng2-dragula/ng2-dragula';

import { UIModule } from '@c4/ui';
import { AuthModule } from '@c4/auth';
import { CoreModule } from '@c4/core';

import { AddProgrammingComponent } from './add-programming/add-programming.component';
import { CodeitemConditionComponent } from './codeitem-condition/codeitem-condition.component';
import { SelectLoopComponent } from './select-loop/select-loop.component';
import { SelectConditionComponent } from './select-condition/select-condition.component';
import { SelectCommandComponent } from './select-command/select-command.component';
import { SelectDeviceComponent } from './select-device/select-device.component';
import { SelectCategoryComponent } from './select-category/select-category.component';
import { SelectEventComponent } from './select-event/select-event';
import { CodeitemCommandComponent } from './codeitem-command/codeitem-command.component';
import { CodeitemLoopComponent } from './codeitem-loop/codeitem-loop.component';
import { ProgrammingActionsComponent } from './actions/actions.component';
import { ProgrammingEventComponent } from './event/event.component';
import { AdvancedComponent } from './advanced.component';
import { ProgrammingListComponent } from './list/list.component';
import { ListSelectorComponent } from './list-selector/list-selector';
import { ParamEditorComponent } from './param-editor/param-editor';
import { SelectTriggerComponent } from './select-trigger/select-trigger';
import { AddCodeitemComponent } from './add-codeitem/add-codeitem.component';
import { ProgrammingCommonModule } from '../common/common.module';
import { AdvancedProgrammingService } from './services/advanced-programming.service';
import { GridSelectorComponent } from './grid-selector/grid-selector.component';

@NgModule({
  imports: [
    // --- angular
    BrowserModule,
    FormsModule,
    HttpModule,
    CommonModule,
    // --- router
    RouterModule,
    // --- @ngrx
    StoreModule,
    // --- third-parties
    DragulaModule,
    // --- framework
    CoreModule,
    AuthModule,
    UIModule,
    // --- locals
    ProgrammingCommonModule
  ],
  declarations: [
    ListSelectorComponent,
    GridSelectorComponent,
    AdvancedComponent,
    ProgrammingEventComponent,
    ProgrammingActionsComponent,
    ProgrammingListComponent,
    CodeitemLoopComponent,
    CodeitemCommandComponent,
    CodeitemConditionComponent,
    SelectEventComponent,
    ParamEditorComponent,
    SelectTriggerComponent,
    SelectCategoryComponent,
    SelectDeviceComponent,
    SelectCommandComponent,
    SelectConditionComponent,
    SelectLoopComponent,
    CodeitemConditionComponent,
    AddProgrammingComponent,
    AddCodeitemComponent
  ],
  providers: [
    AdvancedProgrammingService
  ]
})
export class AdvancedProgrammingModule { }



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/advanced.module.ts